// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clickable[data-v-1da134c6]{cursor:pointer}.sub-asset-row[data-v-1da134c6]{background-color:#f8f9fa}.order-item-thumbnail[data-v-1da134c6]{width:50px;height:50px;overflow:hidden}.placeholder-thumb[data-v-1da134c6]{width:50px;height:50px;background-color:#e9ecef;border-radius:4px}", ""]);
// Exports
module.exports = exports;
